__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "mtapp";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@mui/material", "6.5.0", () => (Promise.all([__webpack_require__.e(49446), __webpack_require__.e(47086), __webpack_require__.e(50202), __webpack_require__.e(71382), __webpack_require__.e(75591), __webpack_require__.e(9988), __webpack_require__.e(63484), __webpack_require__.e(17433), __webpack_require__.e(35177), __webpack_require__.e(89481), __webpack_require__.e(43007), __webpack_require__.e(10515), __webpack_require__.e(65695), __webpack_require__.e(15008), __webpack_require__.e(32013), __webpack_require__.e(13614), __webpack_require__.e(67571), __webpack_require__.e(34541), __webpack_require__.e(43325)]).then(() => (() => (__webpack_require__(913614))))));
			register("@mui/x-data-grid-pro", "7.29.13", () => (Promise.all([__webpack_require__.e(49446), __webpack_require__.e(47086), __webpack_require__.e(50202), __webpack_require__.e(71382), __webpack_require__.e(75591), __webpack_require__.e(9988), __webpack_require__.e(14301), __webpack_require__.e(43007), __webpack_require__.e(5209), __webpack_require__.e(90703), __webpack_require__.e(50979), __webpack_require__.e(85492), __webpack_require__.e(27894), __webpack_require__.e(58504), __webpack_require__.e(67571), __webpack_require__.e(34541), __webpack_require__.e(91010), __webpack_require__.e(50146)]).then(() => (() => (__webpack_require__(308629))))));
			register("@mui/x-license", "7.29.1", () => (Promise.all([__webpack_require__.e(67571), __webpack_require__.e(25307)]).then(() => (() => (__webpack_require__(25307))))));
			register("react-dom", "19.1.0", () => (Promise.all([__webpack_require__.e(67571), __webpack_require__.e(43144)]).then(() => (() => (__webpack_require__(843144))))));
			register("react", "19.1.0", () => (__webpack_require__.e(14041).then(() => (() => (__webpack_require__(514041))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};